import { mapZoom } from '../../../Resources/Private/Fusion/src/scripts/helpers/map-zoom';
import { pinClustering } from '../../../Resources/Private/Fusion/src/scripts/helpers/pin-clustering';

document.addEventListener('alpine:init', () => {
    window.Alpine.data('referencesMap', () => ({
        ...mapZoom(),
        ...pinClustering(),

        pinTooltip: {
            visible: false,
            title: '',
            href: '',
            x: 0,
            y: 0,
        },
        hidePinTooltipTimeout: null,

        init() {
            this.initMapZoom();
            this.initPinClustering();
            // Manual outside-click handling: Alpine's .outside modifier proved unreliable
            // for the conditionally shown tooltip, and taps on other pins must not close it
            this.onDocumentClickHidePinTooltip = (event) => {
                if (!this.pinTooltip.visible) {
                    return;
                }
                if (event.target.closest
                    && (event.target.closest('.references-map-section__pin-link')
                        || event.target.closest('.references-map-section__pin-tooltip'))) {
                    return;
                }
                this.hidePinTooltip();
            };
            document.addEventListener('click', this.onDocumentClickHidePinTooltip);
        },

        destroy() {
            document.removeEventListener('click', this.onDocumentClickHidePinTooltip);
            this.destroyPinClustering();
        },

        showPinTooltip(event, title, href) {
            this.cancelHidePinTooltip();
            // Client rects keep the tooltip anchored correctly at any map zoom level.
            // The SVG <a> wrapper reports zero dimensions, so measure the pin path itself.
            const rootBounds = this.$root.getBoundingClientRect();
            const pinBounds = (event.currentTarget.querySelector('path') || event.currentTarget).getBoundingClientRect();
            this.pinTooltip = {
                visible: true,
                title,
                href,
                x: pinBounds.left - rootBounds.left + pinBounds.width / 2,
                y: pinBounds.top - rootBounds.top,
            };
            // Clamp horizontally after rendering so long titles stay inside the section
            this.$nextTick(() => {
                const tooltip = this.$refs.pinTooltip;
                if (!tooltip) {
                    return;
                }
                const halfWidth = tooltip.offsetWidth / 2;
                this.pinTooltip.x = Math.min(
                    Math.max(this.pinTooltip.x, halfWidth + 8),
                    rootBounds.width - halfWidth - 8,
                );
            });
        },

        hidePinTooltip() {
            this.pinTooltip.visible = false;
        },

        // The grace period lets the cursor travel from the pin into the tooltip link
        scheduleHidePinTooltip() {
            this.cancelHidePinTooltip();
            this.hidePinTooltipTimeout = setTimeout(() => this.hidePinTooltip(), 250);
        },

        cancelHidePinTooltip() {
            clearTimeout(this.hidePinTooltipTimeout);
        },

        // On touch devices the first tap opens the tooltip; a second activation of the
        // same pin follows the link. The second path also keeps the pin usable for
        // screen-reader users, whose activation gestures fire click events.
        interceptPinClickOnTouch(event, title, href) {
            if (!window.matchMedia('(hover: none)').matches) {
                return;
            }
            if (this.pinTooltip.visible && this.pinTooltip.href === href) {
                return;
            }
            event.preventDefault();
            this.showPinTooltip(event, title, href);
        },

    }));
});
